export const links = {
    main: "/",
    scenario: "/send-scenario",
    media: "/medialibrary",
    school: "/school",
    ppm: "/playlist/potential_project_market_2021",
    contests: "/contests",
};

